<template>
	<div class="mt-3">
		<b-row>
			<b-col cols="7" xl="8" lg="7" md="7" sm="6">
				<b-form-group
					label=""
					label-for="per-page-select"
					label-cols-sm="0"
					label-cols-md="0"
					label-cols-lg="0"
					label-align-sm="center"
					label-size="sm"
					class="mb-2"
				>
					<label for="per-page-select" class="mr-2 text-sm">Show</label>
					<b-form-select
						id="per-page-select"
						class="custom-table-entries"
						v-model="perPage"
						:options="pageOptions"
						v-on:input="changePageOption(perPage)"
						size="sm"
					></b-form-select>
					<label for="per-page-select" class="ml-2 text-sm">entries</label>
				</b-form-group>
			</b-col>
			<b-col cols="5" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
				<b-form-group label="" label-for="filter-input" label-align-sm="right" label-size="sm " class="mb-0 per-page-select">
					<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
					<b-input-group size="sm">
						<b-form-input id="filter-input" v-model="filter" class="mb-4"></b-form-input>
					</b-input-group>
				</b-form-group>
			</b-col>
		</b-row>

		<b-table
			striped
			hover
			:items="tableData"
			:fields="tableColumns"
			:current-page="currentPage"
			:per-page="perPage"
			:filter="filter"
			:filter-included-fields="filterOn"
			:sort-by.sync="sortBy"
			:sort-desc.sync="sortDesc"
			:sort-direction="sortDirection"
			head-variant="light"
			table-class="text-nowrap"
			class="primary-table"
			sticky-header="true"
			show-empty
			responsive
			small
		>
			<template #cell(status)="row">
				<span v-if="row.item.status" class="text-success">
					<i class="fas fa-check text-success"></i> success
				</span>
				<span v-if="!row.item.status" class="text-danger">
					<i class="fas fa-exclamation text-danger"></i> Failed
				</span>
			</template>
			<template #cell(message)="row">
				<span v-html="row.item.message"> </span>
			</template>
		</b-table>

		

    <b-row class="mt-4">
      <b-col>
        <p class="ml-3">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
      </b-col>
      <b-col xl="auto" md="auto" sm="auto ">
        <b-pagination
          class="flex-fill-custom pr-4 ml-3"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
        ></b-pagination>
      </b-col>
    </b-row>
    <hr>
    <b-row class="mt-3">
      <b-col xl="6" md="6" sm="6">
        <div class="float-left">
          <base-button type="white" title="Close"  v-on:click="modalClose()">
            Close
          </base-button>
        </div>
      </b-col>
      <b-col xl="6" md="6" sm="6">
        <div class="float-right">

        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import pagination from '../../common/format/pagination'
  export default {
    name: "Import-Detail",
    data() {
      return {
        totalRows: 0,
        currentPage: 1,
        pageOptions: [10, 25, 50, 100],
        perPage: 10,
        tableColumns: [
          {key: 'status', label: 'Status', sortable: true, sortDirection: 'desc'},
          {key: 'id', label: 'Imsi', sortable: true, sortDirection: 'desc'},
          {key: 'message', label: 'Message', sortable: true, sortDirection: 'desc'},
        ],
        tableData: [],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        fromPage: 10,
        loadingStatus: true
      }
    },
    mounted() {
      this.$root.$on('import-detail', (data => {
        this.tableData = [];
        if (data.length < 10) {
          this.fromPage = data.length;
        }
        data.map(item => {
          this.tableData.push(item)
        });
        this.totalRows = this.tableData.length;
        this.loadingStatus = false
      }));
      this.getTotalRows();
    },
    methods: {
      modalClose() {
        this.$bvModal.hide('import-detail')
      },


      getTotalRows() {
        if (this.perPage > this.totalRows) {
          this.fromPage = this.totalRows;
        } else {
          this.fromPage = this.perPage;
        }
      },
      startPage() {
		   return pagination.startPageFunc(this.currentPage, this.perPage)
      }, 
      lastPage() {
        return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
      },
      changePageOption(page) {
        this.getTotalRows();
      },
    }
  }
</script>

<style>
#import-detail___BV_modal_content_ header {
	border-bottom: 1px solid #e9ecef;
}

#import-detail___BV_modal_content_ footer {
	border-top: 1px solid #e9ecef;
	width: 100%;
	justify-content: space-between;
}
</style>
